/** Pantalla a la que va cada perfil al entrar (o cuando intenta abrir algo que no le corresponde):
 * el Administrador solo trabaja en Mantenimiento, el resto en su Dashboard. */
export const rutaInicio = (usuario) => (usuario?.perfil === "Administrador" ? "/mant/usuarios" : "/dashboard");
